export enum Sexe {
    'Femme' = 0, 'Homme' = 1

}
